/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthBuyerRequestDto,
  AuthSupplierRequestDto,
  BulkActiveDto,
  BulkPriceDto,
  CancelContractRequestDto,
  CancelStorefrontOrderDto,
  CmarketCardPaymentCallbackDto,
  CmarketTaxInvoiceCallbackDto,
  CompleteInspectionDto,
  CreateExternalQuoteRequestWithAddressDto,
  CreateOfferingRequestDto,
  CreateStorefrontOrderDto,
  CreateSupplierItemRequestDto,
  EmbedJoinRequestDto,
  EmbedTokenVerifyRequestDto,
  ExtendExternalQuoteRequestDeadlineDto,
  ExternalAccountStatusControllerUpdateStatus200,
  ExternalAdminChatControllerFindMessages200,
  ExternalAdminChatControllerFindMessagesParams,
  ExternalAdminChatControllerFindRooms200,
  ExternalAdminChatControllerFindRoomsParams,
  ExternalAdminParticipationsControllerHide200,
  ExternalAdminParticipationsControllerRemove200,
  ExternalAdminParticipationsControllerUnhide200,
  ExternalAdminQuoteRequestsControllerDeleteOne200,
  ExternalAdminQuoteRequestsControllerFindAll200,
  ExternalAdminQuoteRequestsControllerFindAllParams,
  ExternalAdminQuoteRequestsControllerRestoreOne200,
  ExternalBuyersControllerAuthenticateBuyer201,
  ExternalCategoriesControllerGetCategoryTree200,
  ExternalCategoriesControllerGetCategoryTreeParams,
  ExternalContractsControllerGetContract200,
  ExternalContractsControllerGetContracts200,
  ExternalContractsControllerGetMyContracts200,
  ExternalContractsControllerGetMyContractsParams,
  ExternalContractsControllerGetSettlements200,
  ExternalContractsControllerRequestCancellation200,
  ExternalEmbedControllerGenerateAlimTalkLinks201,
  ExternalEmbedControllerGetEmbedUrl201,
  ExternalEmbedControllerVerifyEmbedToken200,
  ExternalFilesControllerUploadTemporaryFiles201,
  ExternalFilesControllerUploadTemporaryFilesBody,
  ExternalItemSearchControllerSearch200,
  ExternalItemSearchControllerSearchParams,
  ExternalItemsControllerCreateRequest201,
  ExternalItemsControllerGetItems200,
  ExternalItemsControllerGetItemsParams,
  ExternalItemsControllerGetMyRequests200,
  ExternalItemsControllerGetMyRequestsParams,
  ExternalItemsControllerUpdateSettings200,
  ExternalPaymentsControllerConfirmCardPayment201,
  ExternalQuoteRequestsControllerCreateWithAddress201,
  ExternalQuoteRequestsControllerExtendDeadline200,
  ExternalQuoteRequestsControllerFindAll200,
  ExternalQuoteRequestsControllerFindAllParams,
  ExternalQuoteRequestsControllerFindContractDocuments200,
  ExternalQuoteRequestsControllerFindMine200,
  ExternalQuoteRequestsControllerFindMineParams,
  ExternalQuoteRequestsControllerFindModifications200,
  ExternalQuoteRequestsControllerFindOne200,
  ExternalQuoteRequestsControllerFindResponded200,
  ExternalQuoteRequestsControllerFindRespondedParams,
  ExternalQuoteRequestsControllerUpdateOne200,
  ExternalStorefrontControllerGetCategories200,
  ExternalStorefrontControllerGetItem200,
  ExternalStorefrontControllerGetItemOffers200,
  ExternalStorefrontControllerGetItems200,
  ExternalStorefrontControllerGetItemsParams,
  ExternalStorefrontOrdersControllerApplyRequisition200,
  ExternalStorefrontOrdersControllerCancelOrder200,
  ExternalStorefrontOrdersControllerCompleteInspection200,
  ExternalStorefrontOrdersControllerCreateOrder201,
  ExternalStorefrontOrdersControllerGetInspection200,
  ExternalStorefrontOrdersControllerGetOrder200,
  ExternalStorefrontOrdersControllerGetPointBalance200,
  ExternalStorefrontOrdersControllerListOrders200,
  ExternalStorefrontOrdersControllerListOrdersParams,
  ExternalSupplierShipmentsControllerFindMallOrder200,
  ExternalSupplierShipmentsControllerList200,
  ExternalSupplierShipmentsControllerListCouriers200,
  ExternalSupplierShipmentsControllerListMyTargets200,
  ExternalSupplierShipmentsControllerRegister201,
  ExternalSupplierShipmentsControllerUpdateStatus200,
  ExternalSupplierStorefrontsControllerBulkSetActive200,
  ExternalSupplierStorefrontsControllerBulkSetPrices200,
  ExternalSupplierStorefrontsControllerListMine200,
  ExternalSupplierStorefrontsControllerListMyOfferings200,
  ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  ExternalSupplierStorefrontsControllerListMyPrices200,
  ExternalSupplierStorefrontsControllerListMyPricesParams,
  ExternalSupplierStorefrontsControllerListMyRequests200,
  ExternalSupplierStorefrontsControllerListMyRequestsParams,
  ExternalSupplierStorefrontsControllerRequestOffering201,
  ExternalSupplierStorefrontsControllerSetPrice200,
  ExternalSuppliersControllerAuthenticateSupplier201,
  ExternalSuppliersControllerGetSupplierMe200,
  ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200,
  GenerateAlimTalkLinksRequestDto,
  RegisterShipmentDto,
  RequisitionedStorefrontOrderDto,
  SetStorefrontPriceDto,
  UpdateBuyerMeDto,
  UpdateExternalAccountStatusDto,
  UpdateExternalQuoteRequestDto,
  UpdateShipmentStatusDto,
  UpdateSupplierItemSettingsDto,
  UpdateSupplierMeDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * C-Market 마켓플레이스에서 공급자를 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다.
 * @summary C-Market 공급자 자동 인증 및 세션 생성
 */
export const externalSuppliersControllerAuthenticateSupplier = (
  authSupplierRequestDto: BodyType<AuthSupplierRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSuppliersControllerAuthenticateSupplier201>({
    url: `/external/suppliers/auth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: authSupplierRequestDto,
    signal,
  });
};

export const getExternalSuppliersControllerAuthenticateSupplierMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      TError,
      { data: BodyType<AuthSupplierRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>,
    TError,
    { data: BodyType<AuthSupplierRequestDto> },
    TContext
  > => {
    const mutationKey = ["externalSuppliersControllerAuthenticateSupplier"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      { data: BodyType<AuthSupplierRequestDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalSuppliersControllerAuthenticateSupplier(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSuppliersControllerAuthenticateSupplierMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>
  >;
export type ExternalSuppliersControllerAuthenticateSupplierMutationBody =
  BodyType<AuthSupplierRequestDto>;
export type ExternalSuppliersControllerAuthenticateSupplierMutationError =
  ErrorType<unknown>;

/**
 * @summary C-Market 공급자 자동 인증 및 세션 생성
 */
export const useExternalSuppliersControllerAuthenticateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      TError,
      { data: BodyType<AuthSupplierRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>,
  TError,
  { data: BodyType<AuthSupplierRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSuppliersControllerAuthenticateSupplierMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 로그인한 공급사의 저장된 회사 정보를 돌려줍니다(견적서 «공급자» 칸에 씀).
 * @summary 내 공급사 정보 조회
 */
export const externalSuppliersControllerGetSupplierMe = (
  signal?: AbortSignal,
) => {
  return api<ExternalSuppliersControllerGetSupplierMe200>({
    url: `/external/suppliers/me`,
    method: "GET",
    signal,
  });
};

export const getExternalSuppliersControllerGetSupplierMeQueryKey = () => {
  return [`/external/suppliers/me`] as const;
};

export const getExternalSuppliersControllerGetSupplierMeQueryOptions = <
  TData = Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSuppliersControllerGetSupplierMeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>
  > = ({ signal }) => externalSuppliersControllerGetSupplierMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSuppliersControllerGetSupplierMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>
>;
export type ExternalSuppliersControllerGetSupplierMeQueryError =
  ErrorType<unknown>;

export function useExternalSuppliersControllerGetSupplierMe<
  TData = Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
          TError,
          Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSuppliersControllerGetSupplierMe<
  TData = Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
          TError,
          Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSuppliersControllerGetSupplierMe<
  TData = Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 공급사 정보 조회
 */

export function useExternalSuppliersControllerGetSupplierMe<
  TData = Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierMe>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSuppliersControllerGetSupplierMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 공급자 설정 변경
 */
export const externalSuppliersControllerUpdateSupplierMe = (
  updateSupplierMeDto: BodyType<UpdateSupplierMeDto>,
) => {
  return api<void>({
    url: `/external/suppliers/me`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateSupplierMeDto,
  });
};

export const getExternalSuppliersControllerUpdateSupplierMeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
    TError,
    { data: BodyType<UpdateSupplierMeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
  TError,
  { data: BodyType<UpdateSupplierMeDto> },
  TContext
> => {
  const mutationKey = ["externalSuppliersControllerUpdateSupplierMe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
    { data: BodyType<UpdateSupplierMeDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalSuppliersControllerUpdateSupplierMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSuppliersControllerUpdateSupplierMeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>
  >;
export type ExternalSuppliersControllerUpdateSupplierMeMutationBody =
  BodyType<UpdateSupplierMeDto>;
export type ExternalSuppliersControllerUpdateSupplierMeMutationError =
  ErrorType<unknown>;

/**
 * @summary 공급자 설정 변경
 */
export const useExternalSuppliersControllerUpdateSupplierMe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
      TError,
      { data: BodyType<UpdateSupplierMeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
  TError,
  { data: BodyType<UpdateSupplierMeDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSuppliersControllerUpdateSupplierMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 외부 파트너 시스템에서 발주기관(구매사)을 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다. 외부 파트너 검증을 신뢰하므로 별도 NICE 인증 없이 즉시 견적요청 등 NICE-게이트 API를 사용할 수 있습니다.
 * @summary 발주기관(구매사) 자동 인증 및 세션 생성
 */
export const externalBuyersControllerAuthenticateBuyer = (
  authBuyerRequestDto: BodyType<AuthBuyerRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalBuyersControllerAuthenticateBuyer201>({
    url: `/external/buyers/auth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: authBuyerRequestDto,
    signal,
  });
};

export const getExternalBuyersControllerAuthenticateBuyerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
    TError,
    { data: BodyType<AuthBuyerRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
  TError,
  { data: BodyType<AuthBuyerRequestDto> },
  TContext
> => {
  const mutationKey = ["externalBuyersControllerAuthenticateBuyer"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
    { data: BodyType<AuthBuyerRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalBuyersControllerAuthenticateBuyer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalBuyersControllerAuthenticateBuyerMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>
  >;
export type ExternalBuyersControllerAuthenticateBuyerMutationBody =
  BodyType<AuthBuyerRequestDto>;
export type ExternalBuyersControllerAuthenticateBuyerMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관(구매사) 자동 인증 및 세션 생성
 */
export const useExternalBuyersControllerAuthenticateBuyer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
      TError,
      { data: BodyType<AuthBuyerRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
  TError,
  { data: BodyType<AuthBuyerRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalBuyersControllerAuthenticateBuyerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 구매사 설정 변경
 */
export const externalBuyersControllerUpdateBuyerMe = (
  updateBuyerMeDto: BodyType<UpdateBuyerMeDto>,
) => {
  return api<void>({
    url: `/external/buyers/me`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateBuyerMeDto,
  });
};

export const getExternalBuyersControllerUpdateBuyerMeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
    TError,
    { data: BodyType<UpdateBuyerMeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
  TError,
  { data: BodyType<UpdateBuyerMeDto> },
  TContext
> => {
  const mutationKey = ["externalBuyersControllerUpdateBuyerMe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
    { data: BodyType<UpdateBuyerMeDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalBuyersControllerUpdateBuyerMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalBuyersControllerUpdateBuyerMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>
>;
export type ExternalBuyersControllerUpdateBuyerMeMutationBody =
  BodyType<UpdateBuyerMeDto>;
export type ExternalBuyersControllerUpdateBuyerMeMutationError =
  ErrorType<unknown>;

/**
 * @summary 구매사 설정 변경
 */
export const useExternalBuyersControllerUpdateBuyerMe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
      TError,
      { data: BodyType<UpdateBuyerMeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
  TError,
  { data: BodyType<UpdateBuyerMeDto> },
  TContext
> => {
  const mutationOptions =
    getExternalBuyersControllerUpdateBuyerMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Embed Token(OTT)을 검증하고 세션으로 교환합니다. 공급사/발주기관 둘 다 지원.
 * @summary Embed 토큰 검증 및 세션 교환
 */
export const externalEmbedControllerVerifyEmbedToken = (
  embedTokenVerifyRequestDto: BodyType<EmbedTokenVerifyRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerVerifyEmbedToken200>({
    url: `/external/embed/verify`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: embedTokenVerifyRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerVerifyEmbedTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
    TError,
    { data: BodyType<EmbedTokenVerifyRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
  TError,
  { data: BodyType<EmbedTokenVerifyRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerVerifyEmbedToken"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
    { data: BodyType<EmbedTokenVerifyRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerVerifyEmbedToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerVerifyEmbedTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>
>;
export type ExternalEmbedControllerVerifyEmbedTokenMutationBody =
  BodyType<EmbedTokenVerifyRequestDto>;
export type ExternalEmbedControllerVerifyEmbedTokenMutationError =
  ErrorType<unknown>;

/**
 * @summary Embed 토큰 검증 및 세션 교환
 */
export const useExternalEmbedControllerVerifyEmbedToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
      TError,
      { data: BodyType<EmbedTokenVerifyRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
  TError,
  { data: BodyType<EmbedTokenVerifyRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerVerifyEmbedTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알림톡 링크 생성 (테스트용)
 */
export const externalEmbedControllerGenerateAlimTalkLinks = (
  generateAlimTalkLinksRequestDto: BodyType<GenerateAlimTalkLinksRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerGenerateAlimTalkLinks201>({
    url: `/external/alimtalk/links`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateAlimTalkLinksRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerGenerateAlimTalkLinksMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
    TError,
    { data: BodyType<GenerateAlimTalkLinksRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
  TError,
  { data: BodyType<GenerateAlimTalkLinksRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerGenerateAlimTalkLinks"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
    { data: BodyType<GenerateAlimTalkLinksRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerGenerateAlimTalkLinks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerGenerateAlimTalkLinksMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>
  >;
export type ExternalEmbedControllerGenerateAlimTalkLinksMutationBody =
  BodyType<GenerateAlimTalkLinksRequestDto>;
export type ExternalEmbedControllerGenerateAlimTalkLinksMutationError =
  ErrorType<unknown>;

/**
 * @summary 알림톡 링크 생성 (테스트용)
 */
export const useExternalEmbedControllerGenerateAlimTalkLinks = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
      TError,
      { data: BodyType<GenerateAlimTalkLinksRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
  TError,
  { data: BodyType<GenerateAlimTalkLinksRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerGenerateAlimTalkLinksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 인증된 사용자의 역할(공급사 또는 발주기관)에 따라 적절한 Embed URL을 생성합니다.
 * @summary Embed URL 생성 (공급사 / 발주기관 공통)
 */
export const externalEmbedControllerGetEmbedUrl = (
  embedJoinRequestDto: BodyType<EmbedJoinRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerGetEmbedUrl201>({
    url: `/external/embed/join`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: embedJoinRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerGetEmbedUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
    TError,
    { data: BodyType<EmbedJoinRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
  TError,
  { data: BodyType<EmbedJoinRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerGetEmbedUrl"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
    { data: BodyType<EmbedJoinRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerGetEmbedUrl(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerGetEmbedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>
>;
export type ExternalEmbedControllerGetEmbedUrlMutationBody =
  BodyType<EmbedJoinRequestDto>;
export type ExternalEmbedControllerGetEmbedUrlMutationError =
  ErrorType<unknown>;

/**
 * @summary Embed URL 생성 (공급사 / 발주기관 공통)
 */
export const useExternalEmbedControllerGetEmbedUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
      TError,
      { data: BodyType<EmbedJoinRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
  TError,
  { data: BodyType<EmbedJoinRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerGetEmbedUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 카테고리 계층 구조를 트리 형태로 조회합니다.
 * @summary 카테고리 트리 조회 (공급자용)
 */
export const externalCategoriesControllerGetCategoryTree = (
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  signal?: AbortSignal,
) => {
  return api<ExternalCategoriesControllerGetCategoryTree200>({
    url: `/external/categories/tree`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalCategoriesControllerGetCategoryTreeQueryKey = (
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
) => {
  return [`/external/categories/tree`, ...(params ? [params] : [])] as const;
};

export const getExternalCategoriesControllerGetCategoryTreeQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalCategoriesControllerGetCategoryTreeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>
  > = ({ signal }) =>
    externalCategoriesControllerGetCategoryTree(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalCategoriesControllerGetCategoryTreeQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>
  >;
export type ExternalCategoriesControllerGetCategoryTreeQueryError =
  ErrorType<unknown>;

export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalCategoriesControllerGetCategoryTreeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 카테고리 트리 조회 (공급자용)
 */

export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalCategoriesControllerGetCategoryTreeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 공급자 대시보드에서 사용하는 물품 목록 조회 API입니다.
 * @summary 📦 카테고리별 물품 조회 (공급자용)
 */
export const externalItemsControllerGetItems = (
  params?: ExternalItemsControllerGetItemsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerGetItems200>({
    url: `/external/items`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemsControllerGetItemsQueryKey = (
  params?: ExternalItemsControllerGetItemsParams,
) => {
  return [`/external/items`, ...(params ? [params] : [])] as const;
};

export const getExternalItemsControllerGetItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemsControllerGetItemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemsControllerGetItems>>
  > = ({ signal }) => externalItemsControllerGetItems(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemsControllerGetItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerGetItems>>
>;
export type ExternalItemsControllerGetItemsQueryError = ErrorType<unknown>;

export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalItemsControllerGetItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 📦 카테고리별 물품 조회 (공급자용)
 */

export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemsControllerGetItemsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 물품에 대한 나의 공급가 및 판매 상태를 업데이트합니다.
 * @summary ⚙️ 물품별 공급자 설정 업데이트
 */
export const externalItemsControllerUpdateSettings = (
  id: string,
  updateSupplierItemSettingsDto: BodyType<UpdateSupplierItemSettingsDto>,
) => {
  return api<ExternalItemsControllerUpdateSettings200>({
    url: `/external/items/${id}/settings`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateSupplierItemSettingsDto,
  });
};

export const getExternalItemsControllerUpdateSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerUpdateSettings"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
    { id: string; data: BodyType<UpdateSupplierItemSettingsDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalItemsControllerUpdateSettings(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerUpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>
>;
export type ExternalItemsControllerUpdateSettingsMutationBody =
  BodyType<UpdateSupplierItemSettingsDto>;
export type ExternalItemsControllerUpdateSettingsMutationError =
  ErrorType<unknown>;

/**
 * @summary ⚙️ 물품별 공급자 설정 업데이트
 */
export const useExternalItemsControllerUpdateSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
      TError,
      { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerUpdateSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공급자가 새로운 물품 등록을 요청합니다.
 * @summary 물품 등록 요청 제출 (C-Market 전용)
 */
export const externalItemsControllerCreateRequest = (
  createSupplierItemRequestDto: BodyType<CreateSupplierItemRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerCreateRequest201>({
    url: `/external/items/requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSupplierItemRequestDto,
    signal,
  });
};

export const getExternalItemsControllerCreateRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
    TError,
    { data: BodyType<CreateSupplierItemRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
  TError,
  { data: BodyType<CreateSupplierItemRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerCreateRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
    { data: BodyType<CreateSupplierItemRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalItemsControllerCreateRequest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerCreateRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>
>;
export type ExternalItemsControllerCreateRequestMutationBody =
  BodyType<CreateSupplierItemRequestDto>;
export type ExternalItemsControllerCreateRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 물품 등록 요청 제출 (C-Market 전용)
 */
export const useExternalItemsControllerCreateRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
      TError,
      { data: BodyType<CreateSupplierItemRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
  TError,
  { data: BodyType<CreateSupplierItemRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerCreateRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공급자가 직접 등록 요청한 품목들의 상태를 조회합니다.
 * @summary 내가 요청한 품목 등록 내역 조회
 */
export const externalItemsControllerGetMyRequests = (
  params?: ExternalItemsControllerGetMyRequestsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerGetMyRequests200>({
    url: `/external/items/requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemsControllerGetMyRequestsQueryKey = (
  params?: ExternalItemsControllerGetMyRequestsParams,
) => {
  return [`/external/items/requests`, ...(params ? [params] : [])] as const;
};

export const getExternalItemsControllerGetMyRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemsControllerGetMyRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
  > = ({ signal }) => externalItemsControllerGetMyRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemsControllerGetMyRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
>;
export type ExternalItemsControllerGetMyRequestsQueryError = ErrorType<unknown>;

export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalItemsControllerGetMyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 요청한 품목 등록 내역 조회
 */

export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemsControllerGetMyRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 정부 조달 데이터(items_v2_base) 기반 읽기 전용 품목 검색. 파트너 API 키(X-API-Key)로 인증한다(buyer/supplier 세션 토큰도 과도기 동안 함께 허용). 발주기관 공고등록·시약등록 및 공급사 견적 작성에서 공통으로 사용.
 * @summary 🔍 품목 자동완성 검색 (파트너 API 키)
 */
export const externalItemSearchControllerSearch = (
  params: ExternalItemSearchControllerSearchParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemSearchControllerSearch200>({
    url: `/external/items/search`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemSearchControllerSearchQueryKey = (
  params?: ExternalItemSearchControllerSearchParams,
) => {
  return [`/external/items/search`, ...(params ? [params] : [])] as const;
};

export const getExternalItemSearchControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemSearchControllerSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
  > = ({ signal }) => externalItemSearchControllerSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemSearchControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
>;
export type ExternalItemSearchControllerSearchQueryError = ErrorType<unknown>;

export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔍 품목 자동완성 검색 (파트너 API 키)
 */

export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemSearchControllerSearchQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 세모 마스터가 해당 쇼핑몰에 승인한 상품과 판매가를 반환한다. 판매가는 마스터가 정한 규칙(공급사 단가 그대로 / 마진율 / 고정가)이 적용된 값이며, 공급사 정보는 포함되지 않는다.
 * @summary 🛒 쇼핑몰 상품 피드 (파트너 API 키)
 */
export const externalStorefrontControllerGetItems = (
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItems200>({
    url: `/external/storefronts/${slug}/items`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontControllerGetItemsQueryKey = (
  slug?: string,
  params?: ExternalStorefrontControllerGetItemsParams,
) => {
  return [
    `/external/storefronts/${slug}/items`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontControllerGetItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemsQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
  > = ({ signal }) =>
    externalStorefrontControllerGetItems(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
>;
export type ExternalStorefrontControllerGetItemsQueryError = ErrorType<unknown>;

export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: undefined | ExternalStorefrontControllerGetItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 상품 피드 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemsQueryOptions(
    slug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 노출 중인 상품의 대분류·소분류와 건수. 쇼핑몰이 칩을 그리려고 상품 목록을 통째로 받지 않아도 되게 한다 — 2만 건짜리 몰에서는 그 방식이 성립하지 않는다.
 * @summary 🛒 쇼핑몰 카테고리 인덱스 (파트너 API 키)
 */
export const externalStorefrontControllerGetCategories = (
  slug: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetCategories200>({
    url: `/external/storefronts/${slug}/categories`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetCategoriesQueryKey = (
  slug?: string,
) => {
  return [`/external/storefronts/${slug}/categories`] as const;
};

export const getExternalStorefrontControllerGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetCategoriesQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
  > = ({ signal }) => externalStorefrontControllerGetCategories(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
>;
export type ExternalStorefrontControllerGetCategoriesQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 카테고리 인덱스 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetCategoriesQueryOptions(
    slug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 상세 화면용. 목록을 통째로 받아 그 안에서 찾지 않아도 되게 한다 — 승인 품목이 2만 건이 되면 상세 한 장에 목록 100쪽이 딸려온다.
 * @summary 🛒 쇼핑몰 상품 단건 (파트너 API 키)
 */
export const externalStorefrontControllerGetItem = (
  slug: string,
  itemId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItem200>({
    url: `/external/storefronts/${slug}/items/${itemId}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetItemQueryKey = (
  slug?: string,
  itemId?: string,
) => {
  return [`/external/storefronts/${slug}/items/${itemId}`] as const;
};

export const getExternalStorefrontControllerGetItemQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemQueryKey(slug, itemId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
  > = ({ signal }) => externalStorefrontControllerGetItem(slug, itemId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
>;
export type ExternalStorefrontControllerGetItemQueryError = ErrorType<unknown>;

export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 상품 단건 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemQueryOptions(
    slug,
    itemId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 같은 품목을 여러 공급사가 낼 수 있다. 손님에게는 «몇 번째로 싼 값» 만 보여 주고 누가 파는지는 내보내지 않는다. 목록의 price 는 이 리스트의 최저가와 같다.
 * @summary 🛒 품목별 익명 단가 리스트 (파트너 API 키)
 */
export const externalStorefrontControllerGetItemOffers = (
  slug: string,
  itemId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItemOffers200>({
    url: `/external/storefronts/${slug}/items/${itemId}/offers`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetItemOffersQueryKey = (
  slug?: string,
  itemId?: string,
) => {
  return [`/external/storefronts/${slug}/items/${itemId}/offers`] as const;
};

export const getExternalStorefrontControllerGetItemOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemOffersQueryKey(slug, itemId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
  > = ({ signal }) =>
    externalStorefrontControllerGetItemOffers(slug, itemId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
>;
export type ExternalStorefrontControllerGetItemOffersQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 품목별 익명 단가 리스트 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemOffersQueryOptions(
    slug,
    itemId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 포인트 결제 몰(POINT_POSTPAID)에서 그 담당자가 지금 쓸 수 있는 포인트와 원장 이력. 원장 정본은 세모 DB(로트별 사용기한·FEFO)다 — 후불 몰이면 409 다.
 * @summary 🛒 쇼핑몰 포인트 — 잔액·만기 임박·이력 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetPointBalance = (
  slug: string,
  memberNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetPointBalance200>({
    url: `/external/storefronts/${slug}/points/${memberNo}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetPointBalanceQueryKey = (
  slug?: string,
  memberNo?: string,
) => {
  return [`/external/storefronts/${slug}/points/${memberNo}`] as const;
};

export const getExternalStorefrontOrdersControllerGetPointBalanceQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
    >,
    TError = ErrorType<unknown>,
  >(
    slug: string,
    memberNo: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalStorefrontOrdersControllerGetPointBalanceQueryKey(
        slug,
        memberNo,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
      >
    > = ({ signal }) =>
      externalStorefrontOrdersControllerGetPointBalance(slug, memberNo, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!(slug && memberNo),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalStorefrontOrdersControllerGetPointBalanceQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
    >
  >;
export type ExternalStorefrontOrdersControllerGetPointBalanceQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 포인트 — 잔액·만기 임박·이력 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetPointBalanceQueryOptions(
      slug,
      memberNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 장바구니 한 건을 주문으로 남기고 **구매번호**를 채번한다. 단가는 요청 본문에서 받지 않는다 — 서버가 카탈로그에서 다시 확정하므로 화면 금액이 조작돼도 주문 금액은 바뀌지 않는다. `clientOrderKey` 를 같이 보내면 재시도해도 주문이 한 건만 생긴다.
 * @summary 🛒 쇼핑몰 주문 등록 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCreateOrder = (
  slug: string,
  createStorefrontOrderDto: BodyType<CreateStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCreateOrder201>({
    url: `/external/storefronts/${slug}/orders`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCreateOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
    TError,
    { slug: string; data: BodyType<CreateStorefrontOrderDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontOrderDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontOrdersControllerCreateOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
    { slug: string; data: BodyType<CreateStorefrontOrderDto> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return externalStorefrontOrdersControllerCreateOrder(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontOrdersControllerCreateOrderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>
  >;
export type ExternalStorefrontOrdersControllerCreateOrderMutationBody =
  BodyType<CreateStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerCreateOrderMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 쇼핑몰 주문 등록 (파트너 API 키)
 */
export const useExternalStorefrontOrdersControllerCreateOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
      TError,
      { slug: string; data: BodyType<CreateStorefrontOrderDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontOrderDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCreateOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `employeeNo` 를 주면 그 담당자의 주문만, 안 주면 그 몰의 전체 주문을 최신순으로 돌려준다.
 * @summary 🛒 쇼핑몰 주문 내역 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerListOrders = (
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerListOrders200>({
    url: `/external/storefronts/${slug}/orders`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerListOrdersQueryKey = (
  slug?: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
) => {
  return [
    `/external/storefronts/${slug}/orders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontOrdersControllerListOrdersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerListOrdersQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerListOrders(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerListOrdersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>
  >;
export type ExternalStorefrontOrdersControllerListOrdersQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: undefined | ExternalStorefrontOrdersControllerListOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 주문 내역 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerListOrdersQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 🛒 쇼핑몰 주문 1건 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetOrder = (
  slug: string,
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetOrder200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetOrderQueryKey = (
  slug?: string,
  orderNo?: string,
) => {
  return [`/external/storefronts/${slug}/orders/${orderNo}`] as const;
};

export const getExternalStorefrontOrdersControllerGetOrderQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerGetOrderQueryKey(slug, orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerGetOrder(slug, orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && orderNo),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerGetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
>;
export type ExternalStorefrontOrdersControllerGetOrderQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 주문 1건 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetOrderQueryOptions(
      slug,
      orderNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * KCL ERP 가 채번한 구매요구번호를 받아 주문에 반영한다. **이 시점에 거래가 성립한다.** 같은 회신이 두 번 와도 조용히 통과한다 — 씨마켓 통지와 우리 되읽기 스윕이 같은 값을 들고 올 수 있고, 여기서 4xx 를 내면 씨마켓이 그것을 재시도 금지로 분류해 통지가 사라진다.
 * @summary 🛒 구매요구번호 회신 수신 (씨마켓이 호출)
 */
export const externalStorefrontOrdersControllerApplyRequisition = (
  slug: string,
  orderNo: string,
  requisitionedStorefrontOrderDto: BodyType<RequisitionedStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerApplyRequisition200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/requisitioned`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requisitionedStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerApplyRequisitionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
    >,
    TError,
    {
      slug: string;
      orderNo: string;
      data: BodyType<RequisitionedStorefrontOrderDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalStorefrontOrdersControllerApplyRequisition"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      }
    > = (props) => {
      const { slug, orderNo, data } = props ?? {};

      return externalStorefrontOrdersControllerApplyRequisition(
        slug,
        orderNo,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontOrdersControllerApplyRequisitionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
    >
  >;
export type ExternalStorefrontOrdersControllerApplyRequisitionMutationBody =
  BodyType<RequisitionedStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerApplyRequisitionMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 구매요구번호 회신 수신 (씨마켓이 호출)
 */
export const useExternalStorefrontOrdersControllerApplyRequisition = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
  >,
  TError,
  {
    slug: string;
    orderNo: string;
    data: BodyType<RequisitionedStorefrontOrderDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerApplyRequisitionMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 검수 세션과 진행 상태. 대조할 품목(CAS·용량)이 없는 주문은 세션 자체가 없어 null 이다.
 * @summary 🔬 수령검수 상태
 */
export const externalStorefrontOrdersControllerGetInspection = (
  slug: string,
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetInspection200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/inspection`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetInspectionQueryKey = (
  slug?: string,
  orderNo?: string,
) => {
  return [
    `/external/storefronts/${slug}/orders/${orderNo}/inspection`,
  ] as const;
};

export const getExternalStorefrontOrdersControllerGetInspectionQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerGetInspectionQueryKey(slug, orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerGetInspection(slug, orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && orderNo),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerGetInspectionQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>
  >;
export type ExternalStorefrontOrdersControllerGetInspectionQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔬 수령검수 상태
 */

export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetInspectionQueryOptions(
      slug,
      orderNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 검수가 끝났음을 받아 **계산서 보류를 푼다.** 불일치가 남아 있어도 완료로 처리한다 — 게이트가 보는 것은 「대조가 전부 일치했는가」가 아니라 「검수를 마쳤는가」다. 같은 회신이 두 번 와도 조용히 통과한다.
 * @summary 🔬 수령검수 완료 수신 (검수 서버가 호출)
 */
export const externalStorefrontOrdersControllerCompleteInspection = (
  slug: string,
  orderNo: string,
  completeInspectionDto: BodyType<CompleteInspectionDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCompleteInspection200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/inspection/complete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeInspectionDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCompleteInspectionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      TError,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
    >,
    TError,
    { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
    TContext
  > => {
    const mutationKey = [
      "externalStorefrontOrdersControllerCompleteInspection",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> }
    > = (props) => {
      const { slug, orderNo, data } = props ?? {};

      return externalStorefrontOrdersControllerCompleteInspection(
        slug,
        orderNo,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontOrdersControllerCompleteInspectionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
    >
  >;
export type ExternalStorefrontOrdersControllerCompleteInspectionMutationBody =
  BodyType<CompleteInspectionDto>;
export type ExternalStorefrontOrdersControllerCompleteInspectionMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔬 수령검수 완료 수신 (검수 서버가 호출)
 */
export const useExternalStorefrontOrdersControllerCompleteInspection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      TError,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
  >,
  TError,
  { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCompleteInspectionMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * ERP 로 나가기 전(PLACED)에만 취소된다. 전송된 뒤에는 구매요구가 KCL 안에서 돌고 있어 몰이 지울 수 없다 — 그때는 계약 취소 경로다.
 * @summary 🛒 쇼핑몰 주문 취소 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCancelOrder = (
  slug: string,
  orderNo: string,
  cancelStorefrontOrderDto: BodyType<CancelStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCancelOrder200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/cancel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCancelOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
    TError,
    { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
  TError,
  { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontOrdersControllerCancelOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
    { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> }
  > = (props) => {
    const { slug, orderNo, data } = props ?? {};

    return externalStorefrontOrdersControllerCancelOrder(slug, orderNo, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontOrdersControllerCancelOrderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>
  >;
export type ExternalStorefrontOrdersControllerCancelOrderMutationBody =
  BodyType<CancelStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerCancelOrderMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 쇼핑몰 주문 취소 (파트너 API 키)
 */
export const useExternalStorefrontOrdersControllerCancelOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<CancelStorefrontOrderDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
  TError,
  { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCancelOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 송장 등록 화면의 선택지. 코드를 자유 문자열로 두지 않는 이유는 나중에 조회 API 를 붙일 때 값들을 사람이 손으로 정리해야 하기 때문이다.
 * @summary 🚚 택배사 목록 (공급사)
 */
export const externalSupplierShipmentsControllerListCouriers = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerListCouriers200>({
    url: `/external/storefronts/couriers`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListCouriersQueryKey =
  () => {
    return [`/external/storefronts/couriers`] as const;
  };

export const getExternalSupplierShipmentsControllerListCouriersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListCouriersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>
  > = ({ signal }) => externalSupplierShipmentsControllerListCouriers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListCouriersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>
  >;
export type ExternalSupplierShipmentsControllerListCouriersQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 택배사 목록 (공급사)
 */

export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerListCouriersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 계약이 선 뒤부터 배송이 끝나기 전까지의 주문. **남은 수량이 있는 줄만** 온다 — 다 보낸 주문은 목록에서 빠지므로 열어 보고 아무것도 없음을 확인할 필요가 없다.
 * @summary 🚚 내가 보낼 몰 주문 (공급사)
 */
export const externalSupplierShipmentsControllerListMyTargets = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerListMyTargets200>({
    url: `/external/storefronts/my-shipments`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListMyTargetsQueryKey =
  () => {
    return [`/external/storefronts/my-shipments`] as const;
  };

export const getExternalSupplierShipmentsControllerListMyTargetsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListMyTargetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>>
  > = ({ signal }) => externalSupplierShipmentsControllerListMyTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListMyTargetsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>>
  >;
export type ExternalSupplierShipmentsControllerListMyTargetsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 내가 보낼 몰 주문 (공급사)
 */

export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerListMyTargetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 🚚 주문의 배송 목록 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerList = (
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerList200>({
    url: `/external/storefronts/orders/${orderNo}/shipments`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListQueryKey = (
  orderNo?: string,
) => {
  return [`/external/storefronts/orders/${orderNo}/shipments`] as const;
};

export const getExternalSupplierShipmentsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListQueryKey(orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
  > = ({ signal }) => externalSupplierShipmentsControllerList(orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orderNo,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
>;
export type ExternalSupplierShipmentsControllerListQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 주문의 배송 목록 (공급사 · 발주기관)
 */

export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalSupplierShipmentsControllerListQueryOptions(
    orderNo,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 내 몫 품목에 송장을 건다. 주문 수량보다 많이 보낼 수 없고, 송장번호를 적었으면 택배사도 골라야 한다. 마지막 품목까지 도착하면 주문이 배송완료로 바뀐다.
 * @summary 🚚 송장 등록 (공급사)
 */
export const externalSupplierShipmentsControllerRegister = (
  orderNo: string,
  registerShipmentDto: BodyType<RegisterShipmentDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerRegister201>({
    url: `/external/storefronts/orders/${orderNo}/shipments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerShipmentDto,
    signal,
  });
};

export const getExternalSupplierShipmentsControllerRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
    TError,
    { orderNo: string; data: BodyType<RegisterShipmentDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
  TError,
  { orderNo: string; data: BodyType<RegisterShipmentDto> },
  TContext
> => {
  const mutationKey = ["externalSupplierShipmentsControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
    { orderNo: string; data: BodyType<RegisterShipmentDto> }
  > = (props) => {
    const { orderNo, data } = props ?? {};

    return externalSupplierShipmentsControllerRegister(orderNo, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierShipmentsControllerRegisterMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>
  >;
export type ExternalSupplierShipmentsControllerRegisterMutationBody =
  BodyType<RegisterShipmentDto>;
export type ExternalSupplierShipmentsControllerRegisterMutationError =
  ErrorType<unknown>;

/**
 * @summary 🚚 송장 등록 (공급사)
 */
export const useExternalSupplierShipmentsControllerRegister = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
      TError,
      { orderNo: string; data: BodyType<RegisterShipmentDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
  TError,
  { orderNo: string; data: BodyType<RegisterShipmentDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierShipmentsControllerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 그 견적 공고를 낳은 KCL-MRO 몰 주문과 그 주문의 송장을 돌려줍니다. 몰에서 올라온 공고가 아니면 404 입니다.

볼 수 있는 사람은 배송 목록과 같습니다 — 발주기관은 자기 몰 주문, 공급사는 자기 계약이 걸린 주문.
 * @summary 🚚 견적 공고의 몰 주문·배송 현황 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerFindMallOrder = (
  quoteRequestId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerFindMallOrder200>({
    url: `/external/storefronts/quote-requests/${quoteRequestId}/mall-order`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerFindMallOrderQueryKey = (
  quoteRequestId?: string,
) => {
  return [
    `/external/storefronts/quote-requests/${quoteRequestId}/mall-order`,
  ] as const;
};

export const getExternalSupplierShipmentsControllerFindMallOrderQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerFindMallOrderQueryKey(quoteRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>>
  > = ({ signal }) =>
    externalSupplierShipmentsControllerFindMallOrder(quoteRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!quoteRequestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerFindMallOrderQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>>
  >;
export type ExternalSupplierShipmentsControllerFindMallOrderQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 견적 공고의 몰 주문·배송 현황 (공급사 · 발주기관)
 */

export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerFindMallOrderQueryOptions(
      quoteRequestId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 출고 → 배송중 → 배송완료. 잘못 등록한 송장은 `CANCELED` 로 무른다.
 * @summary 🚚 배송 상태 변경 (공급사)
 */
export const externalSupplierShipmentsControllerUpdateStatus = (
  orderNo: string,
  shipmentId: string,
  updateShipmentStatusDto: BodyType<UpdateShipmentStatusDto>,
) => {
  return api<ExternalSupplierShipmentsControllerUpdateStatus200>({
    url: `/external/storefronts/orders/${orderNo}/shipments/${shipmentId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateShipmentStatusDto,
  });
};

export const getExternalSupplierShipmentsControllerUpdateStatusMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      TError,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>,
    TError,
    {
      orderNo: string;
      shipmentId: string;
      data: BodyType<UpdateShipmentStatusDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalSupplierShipmentsControllerUpdateStatus"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      }
    > = (props) => {
      const { orderNo, shipmentId, data } = props ?? {};

      return externalSupplierShipmentsControllerUpdateStatus(
        orderNo,
        shipmentId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierShipmentsControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>
  >;
export type ExternalSupplierShipmentsControllerUpdateStatusMutationBody =
  BodyType<UpdateShipmentStatusDto>;
export type ExternalSupplierShipmentsControllerUpdateStatusMutationError =
  ErrorType<unknown>;

/**
 * @summary 🚚 배송 상태 변경 (공급사)
 */
export const useExternalSupplierShipmentsControllerUpdateStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      TError,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>,
  TError,
  {
    orderNo: string;
    shipmentId: string;
    data: BodyType<UpdateShipmentStatusDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierShipmentsControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 물품관리 표에 생길 단가 열 목록. 마스터가 허용해야 생긴다.
 * @summary 내가 열려 있는 쇼핑몰 (공급사)
 */
export const externalSupplierStorefrontsControllerListMine = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMine200>({
    url: `/external/storefronts/mine`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMineQueryKey = () => {
  return [`/external/storefronts/mine`] as const;
};

export const getExternalSupplierStorefrontsControllerListMineQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierStorefrontsControllerListMineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>
  > = ({ signal }) => externalSupplierStorefrontsControllerListMine(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierStorefrontsControllerListMineQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>
  >;
export type ExternalSupplierStorefrontsControllerListMineQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 열려 있는 쇼핑몰 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 물품관리 표 한 페이지분의 품목 id 를 넘기면 그 칸 값들을 준다.
 * @summary 품목별 내 쇼핑몰 단가 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyPrices = (
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyPrices200>({
    url: `/external/storefronts/mine/prices`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyPricesQueryKey = (
  params?: ExternalSupplierStorefrontsControllerListMyPricesParams,
) => {
  return [
    `/external/storefronts/mine/prices`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyPricesQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
    >,
    TError = ErrorType<unknown>,
  >(
    params: ExternalSupplierStorefrontsControllerListMyPricesParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyPricesQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyPrices(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyPricesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyPricesQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 품목별 내 쇼핑몰 단가 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyPricesQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 마스터가 허용한 조합에만 넣을 수 있다. 값을 넣는 순간 그 쇼핑몰에 노출된다.
 * @summary 쇼핑몰 단가 입력 (공급사)
 */
export const externalSupplierStorefrontsControllerSetPrice = (
  storefrontId: string,
  itemId: string,
  setStorefrontPriceDto: BodyType<SetStorefrontPriceDto>,
) => {
  return api<ExternalSupplierStorefrontsControllerSetPrice200>({
    url: `/external/storefronts/${storefrontId}/items/${itemId}/price`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: setStorefrontPriceDto,
  });
};

export const getExternalSupplierStorefrontsControllerSetPriceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
    TError,
    {
      storefrontId: string;
      itemId: string;
      data: BodyType<SetStorefrontPriceDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
  TError,
  {
    storefrontId: string;
    itemId: string;
    data: BodyType<SetStorefrontPriceDto>;
  },
  TContext
> => {
  const mutationKey = ["externalSupplierStorefrontsControllerSetPrice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
    {
      storefrontId: string;
      itemId: string;
      data: BodyType<SetStorefrontPriceDto>;
    }
  > = (props) => {
    const { storefrontId, itemId, data } = props ?? {};

    return externalSupplierStorefrontsControllerSetPrice(
      storefrontId,
      itemId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierStorefrontsControllerSetPriceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>
  >;
export type ExternalSupplierStorefrontsControllerSetPriceMutationBody =
  BodyType<SetStorefrontPriceDto>;
export type ExternalSupplierStorefrontsControllerSetPriceMutationError =
  ErrorType<unknown>;

/**
 * @summary 쇼핑몰 단가 입력 (공급사)
 */
export const useExternalSupplierStorefrontsControllerSetPrice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
      TError,
      {
        storefrontId: string;
        itemId: string;
        data: BodyType<SetStorefrontPriceDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
  TError,
  {
    storefrontId: string;
    itemId: string;
    data: BodyType<SetStorefrontPriceDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerSetPriceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이 몰에 허용된 내 품목만 나온다. state 로 «노출 중 / 단가 미입력 / 노출 중지» 를 가른다.
 * @summary 내 몰 상품 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyOfferings = (
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyOfferings200>({
    url: `/external/storefronts/mine/${storefrontId}/offerings`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyOfferingsQueryKey = (
  storefrontId?: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
) => {
  return [
    `/external/storefronts/mine/${storefrontId}/offerings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyOfferingsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
    >,
    TError = ErrorType<unknown>,
  >(
    storefrontId: string,
    params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyOfferingsQueryKey(
        storefrontId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyOfferings(
        storefrontId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!storefrontId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyOfferingsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyOfferingsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params:
    | undefined
    | ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 몰 상품 목록 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyOfferingsQueryOptions(
      storefrontId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * copy_base 는 내 단가를 그대로 복사하고, link 는 앞으로도 내 단가를 따라가게 한다. 기본은 미리보기(dryRun)이고, 이미 값이 있는 줄은 덮지 않는다.
 * @summary 몰 단가 일괄 설정 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetPrices = (
  storefrontId: string,
  bulkPriceDto: BodyType<BulkPriceDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerBulkSetPrices200>({
    url: `/external/storefronts/mine/${storefrontId}/prices/bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkPriceDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerBulkSetPricesMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkPriceDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
    >,
    TError,
    { storefrontId: string; data: BodyType<BulkPriceDto> },
    TContext
  > => {
    const mutationKey = ["externalSupplierStorefrontsControllerBulkSetPrices"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      { storefrontId: string; data: BodyType<BulkPriceDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerBulkSetPrices(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
    >
  >;
export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationBody =
  BodyType<BulkPriceDto>;
export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationError =
  ErrorType<unknown>;

/**
 * @summary 몰 단가 일괄 설정 (공급사)
 */
export const useExternalSupplierStorefrontsControllerBulkSetPrices = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkPriceDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
  >,
  TError,
  { storefrontId: string; data: BodyType<BulkPriceDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerBulkSetPricesMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 품절·단종을 한 번에 내린다. 승인은 남으므로 다시 켤 수 있다.
 * @summary 내 몰 상품 노출 일괄 중지/재개 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetActive = (
  storefrontId: string,
  bulkActiveDto: BodyType<BulkActiveDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerBulkSetActive200>({
    url: `/external/storefronts/mine/${storefrontId}/offerings/bulk-active`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkActiveDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerBulkSetActiveMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkActiveDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
    >,
    TError,
    { storefrontId: string; data: BodyType<BulkActiveDto> },
    TContext
  > => {
    const mutationKey = ["externalSupplierStorefrontsControllerBulkSetActive"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      { storefrontId: string; data: BodyType<BulkActiveDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerBulkSetActive(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
    >
  >;
export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationBody =
  BodyType<BulkActiveDto>;
export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 내 몰 상품 노출 일괄 중지/재개 (공급사)
 */
export const useExternalSupplierStorefrontsControllerBulkSetActive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkActiveDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
  >,
  TError,
  { storefrontId: string; data: BodyType<BulkActiveDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerBulkSetActiveMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 허용되지 않은 품목에 단가를 넣으려 할 때 뜨는 안내의 «요청» 버튼이 이걸 부른다.
 * @summary 이 몰에 품목 승인 요청 (공급사)
 */
export const externalSupplierStorefrontsControllerRequestOffering = (
  storefrontId: string,
  createOfferingRequestDto: BodyType<CreateOfferingRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerRequestOffering201>({
    url: `/external/storefronts/mine/${storefrontId}/requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOfferingRequestDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerRequestOfferingMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      TError,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
    >,
    TError,
    { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
    TContext
  > => {
    const mutationKey = [
      "externalSupplierStorefrontsControllerRequestOffering",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerRequestOffering(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerRequestOfferingMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
    >
  >;
export type ExternalSupplierStorefrontsControllerRequestOfferingMutationBody =
  BodyType<CreateOfferingRequestDto>;
export type ExternalSupplierStorefrontsControllerRequestOfferingMutationError =
  ErrorType<unknown>;

/**
 * @summary 이 몰에 품목 승인 요청 (공급사)
 */
export const useExternalSupplierStorefrontsControllerRequestOffering = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      TError,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
  >,
  TError,
  { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerRequestOfferingMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 승인 요청 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyRequests = (
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyRequests200>({
    url: `/external/storefronts/mine/${storefrontId}/requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyRequestsQueryKey = (
  storefrontId?: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
) => {
  return [
    `/external/storefronts/mine/${storefrontId}/requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyRequestsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
    >,
    TError = ErrorType<unknown>,
  >(
    storefrontId: string,
    params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyRequestsQueryKey(
        storefrontId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyRequests(
        storefrontId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!storefrontId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyRequestsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyRequestsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params: undefined | ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 승인 요청 목록 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyRequestsQueryOptions(
      storefrontId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 외부 임베드 세션에서 견적요청/견적응답 첨부파일을 SEMO 스토리지에 직접 업로드합니다. 최대 10개, 파일당 20MB.
 * @summary 🔼 외부 임시 파일 업로드 (C-Market 발주기관/공급사 공용, 24시간 자동 삭제)
 */
export const externalFilesControllerUploadTemporaryFiles = (
  externalFilesControllerUploadTemporaryFilesBody: BodyType<ExternalFilesControllerUploadTemporaryFilesBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  externalFilesControllerUploadTemporaryFilesBody.files.forEach((value) =>
    formData.append(`files`, value),
  );

  return api<ExternalFilesControllerUploadTemporaryFiles201>({
    url: `/external/files/upload-temporary`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getExternalFilesControllerUploadTemporaryFilesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
    TError,
    { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationKey = ["externalFilesControllerUploadTemporaryFiles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
    { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return externalFilesControllerUploadTemporaryFiles(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalFilesControllerUploadTemporaryFilesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>
  >;
export type ExternalFilesControllerUploadTemporaryFilesMutationBody =
  BodyType<ExternalFilesControllerUploadTemporaryFilesBody>;
export type ExternalFilesControllerUploadTemporaryFilesMutationError =
  ErrorType<void>;

/**
 * @summary 🔼 외부 임시 파일 업로드 (C-Market 발주기관/공급사 공용, 24시간 자동 삭제)
 */
export const useExternalFilesControllerUploadTemporaryFiles = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
      TError,
      { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationOptions =
    getExternalFilesControllerUploadTemporaryFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 외부 발주기관이 주소를 미리 저장하지 않고도 공고를 등록할 수 있도록 주소와 공고를 한 번에 받습니다. 내부적으로 주소를 upsert 한 뒤 그 ID 로 공고를 생성합니다.
 * @summary 발주기관 공고 등록 — 주소 인라인 입력
 */
export const externalQuoteRequestsControllerCreateWithAddress = (
  createExternalQuoteRequestWithAddressDto: BodyType<CreateExternalQuoteRequestWithAddressDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerCreateWithAddress201>({
    url: `/external/quote-requests/with-address`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createExternalQuoteRequestWithAddressDto,
    signal,
  });
};

export const getExternalQuoteRequestsControllerCreateWithAddressMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      TError,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
    >,
    TError,
    { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
    TContext
  > => {
    const mutationKey = ["externalQuoteRequestsControllerCreateWithAddress"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalQuoteRequestsControllerCreateWithAddress(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalQuoteRequestsControllerCreateWithAddressMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>>
  >;
export type ExternalQuoteRequestsControllerCreateWithAddressMutationBody =
  BodyType<CreateExternalQuoteRequestWithAddressDto>;
export type ExternalQuoteRequestsControllerCreateWithAddressMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 등록 — 주소 인라인 입력
 */
export const useExternalQuoteRequestsControllerCreateWithAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      TError,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>>,
  TError,
  { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerCreateWithAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 전체 견적 요청 목록 조회 (공급사 · 발주기관)
 */
export const externalQuoteRequestsControllerFindAll = (
  params?: ExternalQuoteRequestsControllerFindAllParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindAll200>({
    url: `/external/quote-requests/all`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindAllQueryKey = (
  params?: ExternalQuoteRequestsControllerFindAllParams,
) => {
  return [`/external/quote-requests/all`, ...(params ? [params] : [])] as const;
};

export const getExternalQuoteRequestsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindAllQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
  > = ({ signal }) => externalQuoteRequestsControllerFindAll(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
>;
export type ExternalQuoteRequestsControllerFindAllQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 전체 견적 요청 목록 조회 (공급사 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindAllQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 나의 공고 목록 조회 (발주기관 전용)
 */
export const externalQuoteRequestsControllerFindMine = (
  params?: ExternalQuoteRequestsControllerFindMineParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindMine200>({
    url: `/external/quote-requests/mine`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindMineQueryKey = (
  params?: ExternalQuoteRequestsControllerFindMineParams,
) => {
  return [
    `/external/quote-requests/mine`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalQuoteRequestsControllerFindMineQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindMineQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
  > = ({ signal }) => externalQuoteRequestsControllerFindMine(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
>;
export type ExternalQuoteRequestsControllerFindMineQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindMineParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 나의 공고 목록 조회 (발주기관 전용)
 */

export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindMineQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 응답한 견적 요청 목록 조회 (공급자 전용)
 */
export const externalQuoteRequestsControllerFindResponded = (
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindResponded200>({
    url: `/external/quote-requests/responded`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindRespondedQueryKey = (
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
) => {
  return [
    `/external/quote-requests/responded`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalQuoteRequestsControllerFindRespondedQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindRespondedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>
  > = ({ signal }) =>
    externalQuoteRequestsControllerFindResponded(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindRespondedQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>
  >;
export type ExternalQuoteRequestsControllerFindRespondedQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindRespondedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 응답한 견적 요청 목록 조회 (공급자 전용)
 */

export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindRespondedQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적 요청 상세 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindOne200>({
    url: `/external/quote-requests/${id}`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindOneQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}`] as const;
};

export const getExternalQuoteRequestsControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindOneQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
  > = ({ signal }) => externalQuoteRequestsControllerFindOne(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
>;
export type ExternalQuoteRequestsControllerFindOneQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청 상세 조회 (공급자 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindOneQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 본인이 등록한 진행중 공고를 수정합니다. 응답(자동견적 포함)이 하나라도 있거나, 마감됐거나, 진행중이 아니면 409 로 거절합니다. 보내지 않은 필드는 그대로 유지됩니다(PATCH 시맨틱).

**attachments** — 보낸 배열로 목록을 통째로 교체합니다(부분 추가/삭제가 아닙니다). 키를 생략하면 기존 첨부가 유지되고, `[]` 또는 `null` 이면 전체 삭제됩니다. 저장되는 필드는 등록과 같은 `fileName`/`url`/`fileSize`/`contentType` 이며 `filePath` 는 보관하지 않습니다.

**projectName** — 물품(product) 카테고리에서 `items` 를 보내면서 `projectName` 을 생략하면 제목을 품목 기준으로 다시 만듭니다(1건이면 품목명, 2건 이상이면 `첫 품목명 외 N개`). `projectName` 을 명시하면 그 값이 우선합니다. `items` 를 보내지 않으면 제목은 건드리지 않습니다.
 * @summary 발주기관 공고 수정 — 참여 업체가 없을 때만
 */
export const externalQuoteRequestsControllerUpdateOne = (
  id: string,
  updateExternalQuoteRequestDto: BodyType<UpdateExternalQuoteRequestDto>,
) => {
  return api<ExternalQuoteRequestsControllerUpdateOne200>({
    url: `/external/quote-requests/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateExternalQuoteRequestDto,
  });
};

export const getExternalQuoteRequestsControllerUpdateOneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
    TError,
    { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
  TError,
  { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
  TContext
> => {
  const mutationKey = ["externalQuoteRequestsControllerUpdateOne"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
    { id: string; data: BodyType<UpdateExternalQuoteRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalQuoteRequestsControllerUpdateOne(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalQuoteRequestsControllerUpdateOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>
  >;
export type ExternalQuoteRequestsControllerUpdateOneMutationBody =
  BodyType<UpdateExternalQuoteRequestDto>;
export type ExternalQuoteRequestsControllerUpdateOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 수정 — 참여 업체가 없을 때만
 */
export const useExternalQuoteRequestsControllerUpdateOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
      TError,
      { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
  TError,
  { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerUpdateOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 해당 견적요청이 언제 무엇이 바뀌었는지를 최신순으로 돌려줍니다. 씨마켓 경유 수정뿐 아니라 **세모에서 직접 수정한 건도 포함**됩니다.

수정이 없으면 빈 배열입니다(404 아님). 등록·마감은 이 목록에 포함되지 않습니다 — 수정만 담습니다.

`summary` 는 조회 시점에 `changes` 로부터 만들어집니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다. 없는 공고면 404 입니다(빈 배열이 아닙니다).
 * @summary 견적 요청 수정 이력 조회 (최신순)
 */
export const externalQuoteRequestsControllerFindModifications = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindModifications200>({
    url: `/external/quote-requests/${id}/modifications`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindModificationsQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}/modifications`] as const;
};

export const getExternalQuoteRequestsControllerFindModificationsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindModificationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindModifications>>
  > = ({ signal }) =>
    externalQuoteRequestsControllerFindModifications(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindModifications>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindModificationsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindModifications>>
  >;
export type ExternalQuoteRequestsControllerFindModificationsQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청 수정 이력 조회 (최신순)
 */

export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindModificationsQueryOptions(
      id,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 해당 견적요청으로 체결된 계약의 계약서류를 계약별로 묶어 돌려줍니다. 발주기관은 전체 계약을, 공급사는 자기 계약만 봅니다.

계약이 아직 없으면 빈 배열입니다(404 아님). 취소된 계약은 제외됩니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다.
 * @summary 견적 요청의 계약서류 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindContractDocuments = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindContractDocuments200>({
    url: `/external/quote-requests/${id}/contract-documents`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindContractDocumentsQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}/contract-documents`] as const;
};

export const getExternalQuoteRequestsControllerFindContractDocumentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
    >,
    TError = ErrorType<unknown>,
  >(
    id: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalQuoteRequestsControllerFindContractDocumentsQueryKey(id);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
      >
    > = ({ signal }) =>
      externalQuoteRequestsControllerFindContractDocuments(id, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalQuoteRequestsControllerFindContractDocumentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
    >
  >;
export type ExternalQuoteRequestsControllerFindContractDocumentsQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청의 계약서류 조회 (공급자 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindContractDocumentsQueryOptions(
      id,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 본인이 등록한 공고의 마감일시를 뒤로 미룹니다. 공고 수정과 달리 응답이 있어도 연장할 수 있습니다(연장은 이미 받은 견적을 무효화하지 않습니다). 마감일이 지나 대기(ON_HOLD)로 내려간 공고는 연장과 함께 진행중으로 되돌아갑니다. 새 마감일시가 과거이거나 기존 마감일시보다 앞서거나 30일을 넘겨 미루면 400, 이미 마감(CLOSED)된 공고는 409 입니다.
 * @summary 발주기관 공고 마감 연장 — 참여 업체가 있어도 가능
 */
export const externalQuoteRequestsControllerExtendDeadline = (
  id: string,
  extendExternalQuoteRequestDeadlineDto: BodyType<ExtendExternalQuoteRequestDeadlineDto>,
) => {
  return api<ExternalQuoteRequestsControllerExtendDeadline200>({
    url: `/external/quote-requests/${id}/deadline`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: extendExternalQuoteRequestDeadlineDto,
  });
};

export const getExternalQuoteRequestsControllerExtendDeadlineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
    TError,
    { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
  TError,
  { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
  TContext
> => {
  const mutationKey = ["externalQuoteRequestsControllerExtendDeadline"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
    { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalQuoteRequestsControllerExtendDeadline(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalQuoteRequestsControllerExtendDeadlineMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>
  >;
export type ExternalQuoteRequestsControllerExtendDeadlineMutationBody =
  BodyType<ExtendExternalQuoteRequestDeadlineDto>;
export type ExternalQuoteRequestsControllerExtendDeadlineMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 마감 연장 — 참여 업체가 있어도 가능
 */
export const useExternalQuoteRequestsControllerExtendDeadline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
      TError,
      { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
  TError,
  { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerExtendDeadlineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 현재 로그인된 공급자의 모든 계약 내역을 조회합니다.
 * @summary 공급자 계약 리스트 조회 (C-Market)
 */
export const externalContractsControllerGetContracts = (
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetContracts200>({
    url: `/external/contracts`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetContractsQueryKey = () => {
  return [`/external/contracts`] as const;
};

export const getExternalContractsControllerGetContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetContractsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
  > = ({ signal }) => externalContractsControllerGetContracts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
>;
export type ExternalContractsControllerGetContractsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 계약 리스트 조회 (C-Market)
 */

export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalContractsControllerGetContractsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 현재 로그인된 발주기관이 체결한 계약을 SEMO 나의 계약과 동일한 기준으로 조회합니다.
 * @summary 발주기관 나의 계약 목록 조회 (C-Market)
 */
export const externalContractsControllerGetMyContracts = (
  params?: ExternalContractsControllerGetMyContractsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetMyContracts200>({
    url: `/external/contracts/mine`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalContractsControllerGetMyContractsQueryKey = (
  params?: ExternalContractsControllerGetMyContractsParams,
) => {
  return [`/external/contracts/mine`, ...(params ? [params] : [])] as const;
};

export const getExternalContractsControllerGetMyContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetMyContractsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
  > = ({ signal }) => externalContractsControllerGetMyContracts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetMyContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
>;
export type ExternalContractsControllerGetMyContractsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalContractsControllerGetMyContractsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 발주기관 나의 계약 목록 조회 (C-Market)
 */

export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalContractsControllerGetMyContractsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 현재 로그인된 공급자의 정산 내역을 조회합니다.
 * @summary 공급자 정산 내역 조회 (C-Market)
 */
export const externalContractsControllerGetSettlements = (
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetSettlements200>({
    url: `/external/contracts/settlements`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetSettlementsQueryKey = () => {
  return [`/external/contracts/settlements`] as const;
};

export const getExternalContractsControllerGetSettlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetSettlementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
  > = ({ signal }) => externalContractsControllerGetSettlements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetSettlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
>;
export type ExternalContractsControllerGetSettlementsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 정산 내역 조회 (C-Market)
 */

export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalContractsControllerGetSettlementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 계약의 상세 정보를 조회합니다.
 * @summary 공급자 계약 상세 조회 (C-Market)
 */
export const externalContractsControllerGetContract = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetContract200>({
    url: `/external/contracts/${id}`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetContractQueryKey = (
  id?: string,
) => {
  return [`/external/contracts/${id}`] as const;
};

export const getExternalContractsControllerGetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetContractQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetContract>>
  > = ({ signal }) => externalContractsControllerGetContract(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetContract>>
>;
export type ExternalContractsControllerGetContractQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 계약 상세 조회 (C-Market)
 */

export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalContractsControllerGetContractQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 계약 당사자(발주기관 또는 공급사)가 취소를 요청합니다. 요청 주체는 세션의 userType에서 판정되며, 반대편 당사자에게 알림/채팅이 발송됩니다. 공급사 요청 시 환불 계좌 정보는 무시되고 결제 원장의 원래 결제 방식대로 처리됩니다.
 * @summary 계약 취소 요청 (C-Market 발주기관 또는 공급사 → 상대편 승인 대기)
 */
export const externalContractsControllerRequestCancellation = (
  id: string,
  cancelContractRequestDto: BodyType<CancelContractRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerRequestCancellation200>({
    url: `/external/contracts/${id}/cancellation-request`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelContractRequestDto,
    signal,
  });
};

export const getExternalContractsControllerRequestCancellationMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>,
    TError,
    { id: string; data: BodyType<CancelContractRequestDto> },
    TContext
  > => {
    const mutationKey = ["externalContractsControllerRequestCancellation"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      { id: string; data: BodyType<CancelContractRequestDto> }
    > = (props) => {
      const { id, data } = props ?? {};

      return externalContractsControllerRequestCancellation(id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalContractsControllerRequestCancellationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>
  >;
export type ExternalContractsControllerRequestCancellationMutationBody =
  BodyType<CancelContractRequestDto>;
export type ExternalContractsControllerRequestCancellationMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 취소 요청 (C-Market 발주기관 또는 공급사 → 상대편 승인 대기)
 */
export const useExternalContractsControllerRequestCancellation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerRequestCancellationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓 결제창에서 카드 승인이 완료되면 호출된다. 수신 즉시 세모에 계약을 확정한다. 재전송돼도 계약이 중복 생성되지 않는다(멱등) — 이미 확정된 건은 alreadyConfirmed=true 로 응답.
 * @summary 씨마켓 카드결제 완료 통지 (업체 직접 계약)
 */
export const externalPaymentsControllerConfirmCardPayment = (
  cmarketCardPaymentCallbackDto: BodyType<CmarketCardPaymentCallbackDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalPaymentsControllerConfirmCardPayment201>({
    url: `/external/payments/cmarket/callback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketCardPaymentCallbackDto,
    signal,
  });
};

export const getExternalPaymentsControllerConfirmCardPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
    TError,
    { data: BodyType<CmarketCardPaymentCallbackDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
  TError,
  { data: BodyType<CmarketCardPaymentCallbackDto> },
  TContext
> => {
  const mutationKey = ["externalPaymentsControllerConfirmCardPayment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
    { data: BodyType<CmarketCardPaymentCallbackDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalPaymentsControllerConfirmCardPayment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalPaymentsControllerConfirmCardPaymentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>
  >;
export type ExternalPaymentsControllerConfirmCardPaymentMutationBody =
  BodyType<CmarketCardPaymentCallbackDto>;
export type ExternalPaymentsControllerConfirmCardPaymentMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 카드결제 완료 통지 (업체 직접 계약)
 */
export const useExternalPaymentsControllerConfirmCardPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
      TError,
      { data: BodyType<CmarketCardPaymentCallbackDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
  TError,
  { data: BodyType<CmarketCardPaymentCallbackDto> },
  TContext
> => {
  const mutationOptions =
    getExternalPaymentsControllerConfirmCardPaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 파트너에서 탈퇴·정지된 회원을 세모에서도 비활성 처리합니다. 프로필은 변경하지 않습니다. 같은 값으로 여러 번 호출해도 안전합니다(changed=false). 세모에 아직 계정이 없으면 404.
 * @summary 파트너 계정 활성/비활성 전환
 */
export const externalAccountStatusControllerUpdateStatus = (
  updateExternalAccountStatusDto: BodyType<UpdateExternalAccountStatusDto>,
) => {
  return api<ExternalAccountStatusControllerUpdateStatus200>({
    url: `/external/accounts/status`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateExternalAccountStatusDto,
  });
};

export const getExternalAccountStatusControllerUpdateStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
    TError,
    { data: BodyType<UpdateExternalAccountStatusDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
  TError,
  { data: BodyType<UpdateExternalAccountStatusDto> },
  TContext
> => {
  const mutationKey = ["externalAccountStatusControllerUpdateStatus"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
    { data: BodyType<UpdateExternalAccountStatusDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalAccountStatusControllerUpdateStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAccountStatusControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>
  >;
export type ExternalAccountStatusControllerUpdateStatusMutationBody =
  BodyType<UpdateExternalAccountStatusDto>;
export type ExternalAccountStatusControllerUpdateStatusMutationError =
  ErrorType<unknown>;

/**
 * @summary 파트너 계정 활성/비활성 전환
 */
export const useExternalAccountStatusControllerUpdateStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
      TError,
      { data: BodyType<UpdateExternalAccountStatusDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
  TError,
  { data: BodyType<UpdateExternalAccountStatusDto> },
  TContext
> => {
  const mutationOptions =
    getExternalAccountStatusControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓 나의 계약 관리에서 계산서가 발행요청·발행·취소되면 호출된다. 같은 통지가 다시 와도 계약 상태가 어긋나지 않는다(멱등). 발행완료 계약에 요청 통지가 뒤늦게 닿으면 무시하고 ignoredAsStale=true 로 응답한다.
 * @summary 씨마켓 계산서 요청·발행·취소 통지
 */
export const externalTaxInvoicesControllerApplyTaxInvoiceEvent = (
  cmarketTaxInvoiceCallbackDto: BodyType<CmarketTaxInvoiceCallbackDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200>({
    url: `/external/tax-invoices/cmarket/callback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketTaxInvoiceCallbackDto,
    signal,
  });
};

export const getExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      TError,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
    >,
    TError,
    { data: BodyType<CmarketTaxInvoiceCallbackDto> },
    TContext
  > => {
    const mutationKey = ["externalTaxInvoicesControllerApplyTaxInvoiceEvent"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalTaxInvoicesControllerApplyTaxInvoiceEvent(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
    >
  >;
export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationBody =
  BodyType<CmarketTaxInvoiceCallbackDto>;
export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 계산서 요청·발행·취소 통지
 */
export const useExternalTaxInvoicesControllerApplyTaxInvoiceEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      TError,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>>,
  TError,
  { data: BodyType<CmarketTaxInvoiceCallbackDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 발주기관 소유와 무관하게, 공개 여부와도 무관하게 세모의 견적요청 전체를 페이지로 돌려줍니다. 회원 토큰이 아니라 파트너 API 키(`X-API-Key`)로 호출합니다.

**`buyerMemberId`** 는 씨마켓 임베드로 가입한 발주기관만 값이 있습니다. 세모에 직접 가입한 발주기관은 `null` 이며, 이 목록에는 그 건도 함께 나옵니다(그것이 이 API 의 목적입니다).

**`responseCount`** 는 캐시 컬럼 기준입니다 — 목록 표시용이며 정산·판정 근거로 쓰지 마세요.

**`isPublic` 필터는 제공하지 않습니다.** 어드민은 공개·비공개를 모두 봐야 하므로 항상 전체가 기본값입니다.

**`categoryType`** 은 단일 값 필터이며(`product`·`construction`·`manufacturing`·`used`), 응답의 `categoryType` 이 내려주는 값을 그대로 넣습니다. `meta.totalCount` 는 **필터가 적용된 건수**입니다 — 페이지 수 계산에 그대로 쓰면 됩니다. 목록에 없는 값을 넣으면 400 이며, 조용히 전체를 돌려주지 않습니다.

**진행중·마감 탭은 `isClosed` 하나로 거세요.** `isClosed=true` 는 수동 마감(`status=CLOSED`) **또는** 마감일 경과입니다 — 이 OR 는 서버가 한 쿼리로 걸어야 총 건수가 맞습니다. 파라미터끼리는 AND 라 `status=CLOSED` 와 `deadlineTo` 를 함께 걸면 교집합이 나옵니다.

**`deadlineFrom`·`deadlineTo`** 는 마감일 축의 범위 필터입니다(`publishedFrom`·`publishedTo` 는 등록일 축이라 다릅니다).

**`status`** 는 계약이 걸린 건을 `CONTRACT_IN_PROGRESS` 로 내려 줍니다 — 상세(`GET /external/quote-requests/{id}`)·회원 피드와 같은 값이라 목록과 상세가 다른 배지를 그리지 않습니다. 계약이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)입니다.

필터로도 네 값을 모두 받습니다. 다만 **`status` 필터는 DB 상태 축**이라, `IN_PROGRESS` 로 거르면 계약이 걸린 건(응답에는 `CONTRACT_IN_PROGRESS` 로 나오는 건)도 DB 상태가 `IN_PROGRESS` 인 한 함께 나옵니다. 계약 건만 고르려면 `status=CONTRACT_IN_PROGRESS` 를 쓰세요.
 * @summary 견적공고 전체 목록 (씨마켓 어드민 전용, 서비스 인증)
 */
export const externalAdminQuoteRequestsControllerFindAll = (
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminQuoteRequestsControllerFindAll200>({
    url: `/external/admin/quote-requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminQuoteRequestsControllerFindAllQueryKey = (
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
) => {
  return [
    `/external/admin/quote-requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalAdminQuoteRequestsControllerFindAllQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminQuoteRequestsControllerFindAllQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>
  > = ({ signal }) =>
    externalAdminQuoteRequestsControllerFindAll(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminQuoteRequestsControllerFindAllQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>
  >;
export type ExternalAdminQuoteRequestsControllerFindAllQueryError =
  ErrorType<unknown>;

export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalAdminQuoteRequestsControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적공고 전체 목록 (씨마켓 어드민 전용, 서비스 인증)
 */

export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalAdminQuoteRequestsControllerFindAllQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 견적요청을 **사용자 화면에서 감춥니다**. 행은 지우지 않으므로 `POST /external/admin/quote-requests/{id}/restore` 로 되돌릴 수 있습니다.

**식별자**는 조회와 같습니다 — UUID · 공고번호(`AA0115`) · bid id(`AA0115_2`) 모두 받습니다.

**딸린 계약·결제·공급사 견적·채팅방이 함께 감춰집니다.** 공고만 감추면 발주기관 「나의 계약」과 공급사 「내 견적」에 그대로 남기 때문입니다. 참여 업체가 있어도 막지 않습니다.

어드민 목록·정산·수수료 집계는 계속 보입니다 — 감추는 곳은 발주기관·공급사 화면뿐입니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 지웠는지 감사 로그에 남깁니다. 파트너 키만으로는 "씨마켓" 까지만 식별됩니다.
 * @summary 견적공고 삭제 (씨마켓 어드민 전용, 복원 가능)
 */
export const externalAdminQuoteRequestsControllerDeleteOne = (id: string) => {
  return api<ExternalAdminQuoteRequestsControllerDeleteOne200>({
    url: `/external/admin/quote-requests/${id}`,
    method: "DELETE",
  });
};

export const getExternalAdminQuoteRequestsControllerDeleteOneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalAdminQuoteRequestsControllerDeleteOne"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalAdminQuoteRequestsControllerDeleteOne(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminQuoteRequestsControllerDeleteOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>
  >;

export type ExternalAdminQuoteRequestsControllerDeleteOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적공고 삭제 (씨마켓 어드민 전용, 복원 가능)
 */
export const useExternalAdminQuoteRequestsControllerDeleteOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminQuoteRequestsControllerDeleteOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 삭제된 견적요청과 **함께 감춰졌던 계약·결제·견적·채팅방**을 사용자 화면으로 되돌립니다.

삭제되지 않은 공고에 부르면 아무 것도 하지 않고 성공합니다(멱등).

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 견적공고 삭제 취소 (씨마켓 어드민 전용)
 */
export const externalAdminQuoteRequestsControllerRestoreOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminQuoteRequestsControllerRestoreOne200>({
    url: `/external/admin/quote-requests/${id}/restore`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminQuoteRequestsControllerRestoreOneMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      TError,
      { id: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>,
    TError,
    { id: string },
    TContext
  > => {
    const mutationKey = ["externalAdminQuoteRequestsControllerRestoreOne"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      { id: string }
    > = (props) => {
      const { id } = props ?? {};

      return externalAdminQuoteRequestsControllerRestoreOne(id);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalAdminQuoteRequestsControllerRestoreOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>
  >;

export type ExternalAdminQuoteRequestsControllerRestoreOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적공고 삭제 취소 (씨마켓 어드민 전용)
 */
export const useExternalAdminQuoteRequestsControllerRestoreOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminQuoteRequestsControllerRestoreOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `quoteRequestId` · `requestNumber` · `externalSupplierId` 중 **최소 하나**로 방을 찾습니다. 조건이 하나도 없으면 400 입니다(전량 조회는 열지 않습니다).

`requestNumber` 는 씨마켓 bid id 형태('AA0014_2')도 받습니다 — `_` 뒤를 떼고 `SE` 접두사를 붙여 해석합니다.

`externalSupplierId` 는 씨마켓 공급사 회원 ID 입니다(SEMO `suppliers.supplier_id`).
 * @summary 채팅방 목록 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindRooms = (
  params?: ExternalAdminChatControllerFindRoomsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminChatControllerFindRooms200>({
    url: `/external/admin/chat-rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminChatControllerFindRoomsQueryKey = (
  params?: ExternalAdminChatControllerFindRoomsParams,
) => {
  return [`/external/admin/chat-rooms`, ...(params ? [params] : [])] as const;
};

export const getExternalAdminChatControllerFindRoomsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminChatControllerFindRoomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
  > = ({ signal }) => externalAdminChatControllerFindRooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminChatControllerFindRoomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
>;
export type ExternalAdminChatControllerFindRoomsQueryError = ErrorType<unknown>;

export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalAdminChatControllerFindRoomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅방 목록 조회 (씨마켓 운영자 전용, 읽기 전용)
 */

export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalAdminChatControllerFindRoomsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 응답 형태는 회원용 `GET /chat/rooms/{roomId}/messages` 와 **동일합니다** — admin2 가 기존 화면 코드를 그대로 씁니다.

**발주기관이 본 그대로**를 돌려줍니다. 공급사에게 숨기는 카드(계약서류 선택 등)까지 포함한 전체입니다 — 운영자가 문의에 답하려면 반쪽이 아니라 전체가 필요합니다.

첨부는 만료가 짧은 서명 URL 로 내려갑니다(회원 경로와 같은 생성기).
 * @summary 채팅 메시지 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindMessages = (
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminChatControllerFindMessages200>({
    url: `/external/admin/chat-rooms/${roomId}/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminChatControllerFindMessagesQueryKey = (
  roomId?: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
) => {
  return [
    `/external/admin/chat-rooms/${roomId}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalAdminChatControllerFindMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminChatControllerFindMessagesQueryKey(roomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
  > = ({ signal }) =>
    externalAdminChatControllerFindMessages(roomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminChatControllerFindMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
>;
export type ExternalAdminChatControllerFindMessagesQueryError =
  ErrorType<unknown>;

export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params: undefined | ExternalAdminChatControllerFindMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅 메시지 조회 (씨마켓 운영자 전용, 읽기 전용)
 */

export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalAdminChatControllerFindMessagesQueryOptions(
    roomId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 이 참여(채팅방 + 딸린 견적)를 **발주기관·공급사 화면에서 감춥니다.** 참여 수와 「견적 N건」에서도 함께 빠집니다.

운영자 목록(`GET /external/admin/chat-rooms`)에는 `participationState: "hidden"` 으로 계속 나옵니다 — 감춘 것이 보여야 되살릴 수 있습니다.

**계약이 진행 중이거나 결제가 오간 참여는 409 로 막힙니다.** 계약서·세금계산서가 그 견적을 되읽기 때문에, 감추는 순간 데이터 정리가 아니라 기능 고장이 됩니다.

이미 숨김 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 감췄는지 감사 로그에 남깁니다.
 * @summary 공급사 참여 이력 숨기기 (씨마켓 운영자 전용, 되살릴 수 있음)
 */
export const externalAdminParticipationsControllerHide = (
  roomId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminParticipationsControllerHide200>({
    url: `/external/admin/participations/${roomId}/hide`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminParticipationsControllerHideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerHide"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerHide(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerHideMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>
  >;

export type ExternalAdminParticipationsControllerHideMutationError =
  ErrorType<unknown>;

/**
 * @summary 공급사 참여 이력 숨기기 (씨마켓 운영자 전용, 되살릴 수 있음)
 */
export const useExternalAdminParticipationsControllerHide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerHideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 숨김 상태의 참여를 발주기관·공급사 화면으로 되돌립니다. 참여 수와 「견적 N건」도 함께 돌아옵니다.

이미 정상 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 숨긴 참여 이력 되살리기 (씨마켓 운영자 전용)
 */
export const externalAdminParticipationsControllerUnhide = (
  roomId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminParticipationsControllerUnhide200>({
    url: `/external/admin/participations/${roomId}/unhide`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminParticipationsControllerUnhideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerUnhide"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerUnhide(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerUnhideMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>
  >;

export type ExternalAdminParticipationsControllerUnhideMutationError =
  ErrorType<unknown>;

/**
 * @summary 숨긴 참여 이력 되살리기 (씨마켓 운영자 전용)
 */
export const useExternalAdminParticipationsControllerUnhide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerUnhideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 숨김 상태의 참여를 **실제로 지웁니다.** 견적·견적서 버전·대화방과 그 업체와 주고받은 대화가 함께 사라지며 **되돌릴 수 없습니다.**

**숨김을 거치지 않은 참여는 409 로 막힙니다** — 먼저 `POST /external/admin/participations/{roomId}/hide` 를 부르고, 감춰진 결과를 확인한 뒤에 지웁니다. 계약·결제가 걸린 참여도 409 입니다.

무엇이 사라졌는지를 수치로 돌려줍니다. 화면에서 사람에게 그대로 보여 주십시오.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 참여 이력 삭제 (씨마켓 운영자 전용) — 되돌릴 수 없음
 */
export const externalAdminParticipationsControllerRemove = (roomId: string) => {
  return api<ExternalAdminParticipationsControllerRemove200>({
    url: `/external/admin/participations/${roomId}`,
    method: "DELETE",
  });
};

export const getExternalAdminParticipationsControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerRemove(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerRemoveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>
  >;

export type ExternalAdminParticipationsControllerRemoveMutationError =
  ErrorType<unknown>;

/**
 * @summary 참여 이력 삭제 (씨마켓 운영자 전용) — 되돌릴 수 없음
 */
export const useExternalAdminParticipationsControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
